<template>
    <ol class="step-nav mx-auto mt-2 mb-0" aria-label="progress">
        <li
            v-for="n in total"
            :key="n"
            class="step-nav-item"
            :class="{
                'is-active': n === active,
                'is-done': n < active,
            }"
        >
            <span
                class="step-dot"
                :aria-current="n === active ? 'step' : null"
                :aria-label="n < active
                    ? $t('stepIndicator.completed', { current: n })
                    : $t('stepIndicator.label', { current: n, total: total })"
            >
                <b-icon-check v-if="n < active" aria-hidden="true" />
                <template v-else>{{ n }}</template>
            </span>
        </li>
    </ol>
</template>

<script>
    export default {
        name: 'NavigationBar',
        props: {
            active: Number,
            total: { type: Number, default: 5 },
        },
    }
</script>

<style scoped>
.step-nav {
    display: flex;
    justify-content: center;
    align-items: center;
    list-style: none;
    padding: 0;
}

.step-nav-item {
    display: flex;
    align-items: center;
}

.step-nav-item:not(:last-child)::after {
    content: '';
    width: 1.25rem;
    height: 2px;
    background-color: var(--brand-light, #e9ecef);
    margin: 0 0.25rem;
}

.step-nav-item.is-done:not(:last-child)::after {
    background-color: var(--brand-primary);
}

.step-dot {
    width: 30px;
    height: 30px;
    min-width: 30px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    font-size: 0.95rem;
    line-height: 1;
    border-radius: var(--brand-radius-pill, 50rem);
    border: 2px solid var(--brand-primary);
    color: var(--brand-primary);
    background: #fff;
}

.step-nav-item.is-active .step-dot {
    background: var(--brand-primary);
    color: #fff;
    box-shadow: 0 0 0 3px rgba(15, 92, 91, 0.2);
}

.step-nav-item.is-done .step-dot {
    background: var(--brand-primary);
    color: #fff;
}
</style>
